export default "__VITE_PUBLIC_ASSET__d98443f8__"